<template>
    <div>
        <el-dialog
                :close-on-click-modal="false"
                :title="title"
                :visible.sync="show"
                width="600px" >
            <div style="width: 100%; height: 100%;" v-loading="loading">
                <div class="w100 pl20 pr20 pt20 pb20">
                    <el-form label-width="100px" :model="form" :rules="rules" ref="ruleForm" class="demo-form-inline">
                        <el-form-item label="专题名称" prop="name" style="min-width: 250px;">
                            <el-input v-model="form.name" placeholder="请输入专题名称"></el-input>
                        </el-form-item>
                        <el-form-item label="专题描述" prop="description" style="min-width: 250px;">
                            <el-input v-model="form.description" type="textarea" placeholder="请输入描述"></el-input>
                        </el-form-item>
                        <el-form-item label="选择服务" prop="serveIds" style="min-width: 250px;">
                            <div>
                                <div class="el-select-serve" @click="serveSelect()">
                                    <el-tag
                                            :key="tag.serve_id"
                                            v-for="tag in serveList"
                                            closable
                                            style="margin:0 3px"
                                            type="info"
                                            :disable-transitions="false"
                                            @close="handleClose(tag)">
                                        {{tag.server_name}}
                                    </el-tag>

                                </div>
                                <el-input v-model="form.serveIds" style="display: none"></el-input>
                            </div>

                        </el-form-item>
                        <el-form-item label="专题图标" prop="iconId" style="min-width: 250px;">
                            <div>
                                <el-upload
                                        v-show="!fileList.length"
                                        class="upload-demo"
                                        action="#"
                                        accept=".jpg,.jpeg,.png,.gif"
                                        :show-file-list="false"
                                        :before-upload="handleBeforeUpload"
                                        :on-preview="handlePreview">
                                    <div>

                                        <el-button slot="trigger"  v-if="!fileList.length>=1">
                                            上传<i class="el-icon-upload el-icon--right"></i></el-button>

                                    </div>
                                </el-upload>
                                <div  v-show="!fileList.length" class="el-upload-tip">
                                    图片不超过1M。JPG、PNG格式
                                </div>
                                <div v-if="fileList.length">
                                    <el-image
                                            style="width: 95px;height: 50px;"
                                            class="card-shadow"
                                            :src="fileList[0].url"

                                            fit="contain"
                                            @click="handlePreview"></el-image>
                                    <span @click="handleRemove">
                    <i class="el-icon-delete"></i></span>
                                </div>
                                <el-input v-model="form.iconId" style="display: none"></el-input>
                            </div>

                        </el-form-item>
                        <el-form-item label="专题排序" prop="sort" style="min-width: 250px;">
                            <el-input-number v-model="form.sort" :min="1" :max="100" label="专题排序"></el-input-number>
                        </el-form-item>
                    </el-form>

                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>
                <el-button @click="show = false">取 消</el-button>
            </div>

        </el-dialog>
        <cropperImg ref="cropperImg" :autoCropWidth="285" :autoCropHeight="150" @uploadHttp="uploadHttp"/>
        <select-serve ref="selectServeRef" @sureSelect="sureSelect"/>
    </div>
</template>

<script>
    import SelectServe from "@/components/SelectServe.vue";
    import { sysFileUpload,sysFileDelete} from '@/api/managementCenter/otherApi';
    import {hallSaveOrUpdate} from '@/api/managementCenter/specialManage';
    import cropperImg from '@/components/common/cropperImg.vue'
    export default {
        name: "SpecialDialog",
        components: {SelectServe,cropperImg},
        props: [],
        data() {
            return {
                imgSrc:'',
                fileList: [],
                serveList:[],
                isSelectServe:false,
                show: false,
                loading: false,
                title: "",
                form: {
                    id: "",
                    name: "",
                    description: "",
                    iconId:'',
                    serveIds:"",
                    sort: 1
                },
                rules: {
                    name: [
                        { required: true, message: "请输入专题名称", trigger: "blur" }
                    ],
                    description: [
                        { required: true, message: "请输入专题描述", trigger: "blur" }
                    ],
                    serveIds: [
                        { required: true, message: "请选择服务", trigger: "blur" }
                    ],
                    iconId: [
                        { required: true, message: "请上传专题图片", trigger: "blur" }
                    ],
                    sort: [
                        { required: true, message: "请输入专题排序", trigger: "blur" }
                    ]
                }
            };
        },
        computed: {
        },
        methods: {

            handleRemove() {
                this.deleteFile(this.fileList[0].id)
                this.fileList=[]
            },

            deleteFile(id){
                sysFileDelete(id).then(({data}) => {
                    if(data.code == 0){
                        this.$message.success(  "删除成功!" );
                    }else{
                        this.$message.warning(data.msg|| "删除失败！" );
                    }
                }).catch(err=>{
                    this.$message.error( "删除异常!" );
                })
            },
            uploadHttp(file){
                console.log(file)
                let fd = new FormData();
                fd.append('fromTarget',2)
                fd.append('file',file);
                //上传到后台
                this.loading=true
                sysFileUpload(fd).then(({data}) => {
                    this.loading=false
                    if(data.code == 0) {
                        this.$refs.cropperImg.closeDialog();
                        this.$message.success(  "上传文件成功!" );
                        this.fileList.push(
                            {
                                ...data.data
                            }
                        )
                    }else{
                        this.$message.warning( data.msg|| "上传文件失败!" );
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error(  "上传文件异常!" );
                });
            },
            // 上传文件之前的方法
            handleBeforeUpload(file){
                if(this.fileList.length>0){
                    return this.$message.error('只能上传一张专题图片！');

                }
                // const isLt1M = file.size / 1024 / 1024 < 1;
                // if (!isLt1M) {
                //     this.$message.error('上传图片大小不能超过 1MB!');
                //     return isLt1M
                // }
                this.$refs.cropperImg.uploadImg(file);
                return;

            },
            handlePreview(){
                window.location.href=this.fileList[0].url
            },



            sureSelect(data){
                this.serveList = data
            },
            serveSelect(){
                this.$refs.selectServeRef.openDialog(this.serveList)
            },
            handleClose(tag){
                this.serveList =this.serveList.filter(item=>{
                    return item.serve_id!=tag.serve_id
                })
            },




            // 显示弹框
            dialogShow (type,data) {
                // 重置表单、显示弹框
                this.show = true;
                this.$nextTick(function(){
                    this.$refs["ruleForm"].resetFields();


                    switch (type) {
                        case 'add' :
                            this.fileList=[];
                            this.serveList=[];
                            this.title = "新增专题"
                            this.form={
                                id: "",
                                name: "",
                                description: "",
                                iconId:'',
                                serveIds:[],
                                sort: 1
                            };
                            break;
                        case 'edit' :
                            this.title = "编辑专题"
                            this.form={
                                id: data.id,
                                name: data.name,
                                description: data.description,
                                iconId:'',
                                serveIds:'',
                                sort: data.sort
                            };
                            this.serveList=data.selectedServes||[];
                            this.fileList=[{
                                id:data.iconId,
                                url:data.resUrl
                            }];
                            break;
                    }

                });
            },
            saveOrUpdate(){
                this.loading = true;
                const params={
                    ...this.form,
                    serveIds:this.form.serveIds.split(",")

                }
                hallSaveOrUpdate(params).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.$message.success(  "保存成功!" );
                        this.show=false
                        this.$emit('saveSuccess')

                    }else{
                        this.$message.warning( data.msg|| "保存失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 确定提交
            submitForm (formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveOrUpdate()
                    } else {
                        return false;
                    }
                });
            }
        },
        watch: {
            fileList(value){
                if(value.length){
                    this.form.iconId =value[0].id
                }else{
                    this.form.iconId=""

                }

            },
            serveList(value){
                this.form.serveIds=value.map(item=>{
                    return item.serve_id
                }).join(",")
            },
            show(value){
                if(!value){
                    this.serveList=[];
                }

            }
        },
        filters: {}
    };
</script>

<style scoped lang="less">
    .el-select-serve{
        border-radius: 4px;
        border: 1px solid #e0e0e0;
        min-height: 50px;
        padding: 8px;
        cursor: pointer;
        max-height: 200px;
        overflow: auto;
    }

    .el-icon-delete{
        cursor: pointer;
        vertical-align: top;
        position: relative;
        right: 13px;
        font-weight: bold;
    &:hover{
         box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
     }
    }

</style>
